import { LOCALES } from 'i18n/locales';

export const lineWidthFieldIntl = {
    [LOCALES.ENGLISH]: {
        'lineWidthField.label': 'Total width:',
        'lineWidthField.max': 'max. {maxBuffer}m',
        'lineWidthField.unit': 'm',
        'lineWidthField.tooltip.reduceBuffer': 'Reduce buffer to finish drawing'
    },
    [LOCALES.WELSH]: {
        'lineWidthField.label': '[Total width:]',
        'lineWidthField.max': '[max. {maxBuffer}m]',
        'lineWidthField.unit': 'm',
        'lineWidthField.tooltip.reduceBuffer': '[Reduce buffer to finish drawing]'
    }
};
